// Carry Roll ExplanationBox — renders plain-language explanation (7.5).

import { useResult } from '../../store/selectors';

export function ExplanationBox() {
  const result = useResult();
  return (
    <div
      className="panel"
      data-testid="explanation-box"
      aria-label="Result explanation"
    >
      <h3 className="text-sm font-medium" style={{ color: 'var(--color-text-muted)' }}>
        Why this result
      </h3>
      <p className="mt-2">
        {result.explanation}
      </p>
    </div>
  );
}
